import { DownloadReportResponse, NewNotifications, UploadReportResponse } from "@/global/interfaces";
import { defineStore } from "pinia";
import { ref, type Ref } from "vue";

export type NotificationDrawer = object;

export const useNotificationDrawerStore = defineStore("NotificationDrawer", () => {
  const toggleDrawer: Ref<boolean> = ref(false);

  const setToggleDrawer = (drawerStatus: boolean) => {
    toggleDrawer.value = drawerStatus;
  };
  const getToggleDrawer = (): boolean => {
    return toggleDrawer.value;
  };

  const notificationsList: Ref<(DownloadReportResponse | UploadReportResponse)[]> = ref([]);

  const setNotificationsList = (newNotificationsList: (DownloadReportResponse | UploadReportResponse)[]) => {
    notificationsList.value = newNotificationsList;
  };
  const isNotificationsListInProgress = ref<boolean>(true);
  const setIsNotificationsListInProgress = (status: boolean) => {
    isNotificationsListInProgress.value = status;
  };
  const getIsNotificationsListInProgress = () => {
    return isNotificationsListInProgress;
  };
  const getNotificationsList = (): (DownloadReportResponse | UploadReportResponse)[] => {
    return notificationsList.value;
  };
  const newNotifications: Ref<NewNotifications[]> = ref([]);

  const setNewNotifications = (newNotificationsList: NewNotifications[]) => {
    newNotifications.value = newNotificationsList;
  };
  const getNewNotifications = (): NewNotifications[] => {
    return newNotifications.value;
  };
  const $resetNewNotification = () => {
    newNotifications.value = [];
  };
  const fileName = ref<string>("");
  const setFileName = (name: string) => {
    fileName.value = name;
  };
  const getFileName = (): string => {
    return fileName.value;
  };
  const updateNotificationsList = (newNotificationsList: (DownloadReportResponse | UploadReportResponse)[]) => {
    // Merge existing and new notifications
    const combinedList = [...notificationsList.value, ...newNotificationsList];
    // Deduplicate by jobId, keeping the latest notification for each jobId
    const dedupedMap = new Map<string, DownloadReportResponse | UploadReportResponse>();
    for (const notification of combinedList) {
      dedupedMap.set(notification.jobId, notification);
    }
    const dedupedList = Array.from(dedupedMap.values());
    dedupedList.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB.getTime() - dateA.getTime(); // Descending: latest first
    });
    notificationsList.value = dedupedList;
  };

  const filterNotification = (jobId: string) => {
    const notificationList = notificationsList.value || [];
    const updatedList = jobId ? notificationList.filter((item) => item?.jobId !== jobId) : notificationList.slice();

    notificationsList.value = updatedList;
  };

  return {
    toggleDrawer,
    setToggleDrawer,
    getToggleDrawer,
    notificationsList,
    setNotificationsList,
    getNotificationsList,
    newNotifications,
    setNewNotifications,
    getNewNotifications,
    $resetNewNotification,
    setFileName,
    getFileName,
    getIsNotificationsListInProgress,
    setIsNotificationsListInProgress,
    isNotificationsListInProgress,
    updateNotificationsList,
    filterNotification
  };
});
